import api from './index';
//
let exports = {};

// ====================== 设备租赁/归还单 ==================
// 获取设备租赁/归还单分页列表
exports.getDevcRentVouchers = function (data, callback) {
    api.post('/rent/asset/devc/rent/voucher/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 获取设备租赁/归还单
exports.getDevcRentVoucherInfo = function (params, callback) {
    api.get('/rent/asset/devc/rent/voucher/get')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 保存设备归还单
exports.saveDevcRentGHVoucher = function (data, callback) {
    api.post('/rent/asset/devc/rent/gh/voucher/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 提交设备租赁/归还单
exports.doSubmitDevcRentVoucher = function (data, callback) {
    api.post('/rent/asset/devc/rent/voucher/submit/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 确认设备租赁/归还单
exports.doConfirmDevcRentVoucher = function (data, callback) {
    api.post('/rent/asset/devc/rent/voucher/confirm/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 设备租赁/归还单发货操作
exports.doSendDevcRentVoucher = function (data, callback) {
    api.post('/rent/asset/devc/rent/voucher/send/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 设备租赁/归还单确认到达操作
exports.doConfirmArriveDevcRentVoucher = function (data, callback) {
    api.post('/rent/asset/devc/rent/voucher/confirm/arrive/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 删除设备租赁/归还单
exports.deleteDevcRentVoucher = function (data, callback) {
    api.post('/rent/asset/devc/rent/voucher/delete/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/rentAsset.js
// module id = 177
// module chunks = 0